import { render, staticRenderFns } from "./save-icon.vue?vue&type=template&id=6194adaa&scoped=true"
var script = {}
import style0 from "./save-icon.vue?vue&type=style&index=0&id=6194adaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6194adaa",
  null
  
)

export default component.exports